import styled from 'styled-components';
import themeData from 'utils/theme/themeData';

const { typography } = themeData;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  min-height: 100vh;
  margin: auto;
  padding: 20px;
`;

export const FormWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 25%;
  margin: auto;
`;

export const Title = styled(typography.H1BoldTypography)`
  margin: 0;
  color: ${({ theme }) => theme.colors.black};
`;

export const SubTitle = styled(typography.P1BoldTypography)`
  margin: 0;
  color: ${({ theme }) => theme.colors.grey300};
`;

export const InputLabel = styled(typography.P1BoldTypography)`
  width: 100%;
  margin: 0;
  color: ${({ theme }) => theme.colors.black};
`;

export const Input = styled.input`
  width: 100%;
  padding: 14px 20px;
  font-size: 13px;
  color: ${({ theme }) => theme.colors.black};
  background-color: ${({ theme }) => theme.colors.blueLight};
  border: none;
  border-radius: 4px;
  box-sizing: border-box;

  ::-webkit-input-placeholder {
    font-size: 13px;
    line-height: 20px;
    color: ${({ theme }) => theme.colors.grey002};
  }
  ::-moz-placeholder {
    font-size: 13px;
    line-height: 20px;
    color: ${({ theme }) => theme.colors.grey002};
  }
  :-ms-input-placeholder {
    font-size: 13px;
    line-height: 20px;
    color: ${({ theme }) => theme.colors.grey002};
  }
  :-moz-placeholder {
    font-size: 13px;
    line-height: 20px;
    color: ${({ theme }) => theme.colors.grey002};
  }

  &:focus {
    border: none;
    outline: none;
  }
`;

export const ValidationErrMsg = styled(typography.P2RegularTypography)`
  margin: 0;
  color: ${({ theme }) => theme.colors.redMain};
`;

export const SingleItemSelectWrapper = styled.div`
  display: flex;
  width: 100%;

  & > * + * {
    margin-inline-start: 6px !important;
  }
`;

export const SingleItemSelect = styled(typography.P2RegularTypography)`
  flex: 1;
  margin: 0;
  padding: 4px 0;
  text-align: center;
  color: ${({ theme }) => theme.colors.grey002};
  border: 1px solid ${({ theme }) => theme.colors.grey002};
  border-radius: 8px;
  cursor: pointer;

  ${({ selected, theme }) =>
    selected &&
    `
    color: ${theme.colors.white};
    background-color: ${theme.colors.blueMain};
    border: 1px solid ${theme.colors.blueMain};
  `}
`;

export const SubmitBtn = styled(typography.P2BoldTypography)`
  width: 25%;
  padding: 8px 0;
  color: ${({ theme }) => theme.colors.white};
  background-color: ${({ theme }) => theme.colors.blueMain};
  border: 1px solid ${({ theme }) => theme.colors.blueMain};
  border-radius: 4px;
  cursor: pointer;

  ${({ disabled, theme }) =>
    disabled &&
    `
    color: ${theme.colors.white};
    background-color: ${theme.colors.grey005};
    border: 1px solid ${theme.colors.grey005};
  `}
`;
